import type {LanguageConfig} from '@frontend/types/Locales'

export const ViLanguageConfig: Omit<LanguageConfig, 'loader'> = {
    language: 'vi',
    region: 'vn',
    full: 'vi-VN',
    label: 'Tiếng Việt',
    variations: ['vi', 'vn', 'vi-vn', 'vi_vn'],
    numeral: {
        localeConfig: {
            delimiters: {
                thousands: '.',
                decimal: ',',
            },
            abbreviations: {
                thousand: ' nghìn',
                million: ' triệu',
                billion: ' tỷ',
                trillion: ' nghìn tỷ',
            },
            ordinal(num: number): string {
                return String(num)
            },
        },
    },
    dateTime: {
        loader: () => import('dayjs/locale/vi'),
        dateFormat: 'L',
    },
    googleMaps: {
        localization: {
            language: 'vi',
            region: 'VN',
        },
    },
}
